import { httpRequest } from "../../http";

export interface ValidateConfigResponse {
  errors: string[];
  warnings: string[];
}

export class CommandValidateConfig {
  async run(definitionId: number): Promise<ValidateConfigResponse> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/validate-config/`;
    return httpRequest<ValidateConfigResponse>(url, { method: "POST" });
  }
}
